import React from 'react'
import BtnSecondary from '../button/secondary/BtnSecondary'

interface ModalContentProps {
  title?: React.ReactNode
  closeModal?: () => void
  footerTemplate?: React.ReactNode
  children?: React.ReactNode
}

const ModalContent: React.FC<ModalContentProps> = ({ title, closeModal, footerTemplate, children }) => {
  return (
    <div className="modal-content">
      <div className="modal-header">
        <h4 className="modal-title">{title}</h4>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={closeModal}
        ></button>
      </div>
      <div className="modal-body">
        <div className="container-fluid">{children}</div>
      </div>
      <div className="modal-footer">
        {footerTemplate ?? (
          <BtnSecondary data-dismiss="modal" onClick={closeModal}>
            Chiudi
          </BtnSecondary>
        )}
      </div>
    </div>
  )
}

export default ModalContent
